module.exports = __webpack_public_path__ + "static/dairy-department-coloring-page-cee16647f5f58d21899a5cc43ebbec92.pdf";